"use client";

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { useRecaptcha } from '@/hooks/useRecaptcha';

interface RecaptchaBadgeProviderProps {
  children: React.ReactNode;
}

export default function RecaptchaBadgeProvider({ children }: RecaptchaBadgeProviderProps) {
  const pathname = usePathname();
  const { hideBadge, showBadge } = useRecaptcha();

  useEffect(() => {
    // Afficher le badge uniquement sur la page d'accueil
    if (pathname === '/') {
      showBadge();
    } else {
      hideBadge();
    }
  }, [pathname, hideBadge, showBadge]);

  return <>{children}</>;
} 